"use client";

import { Suspense } from "react";
import ContactForm from "./ContactForm";

export default function ContactPage() {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-[40vh] items-center justify-center text-sm text-gray-500">
          문의 페이지를 불러오는 중…
        </div>
      }
    >
      <ContactForm />
    </Suspense>
  );
}
